import { ApplicationDispatch, SET_IP_BLOCKED } from "../store/application/types";

export interface IpBlockResponse {
  error: string;
  type: "ip_blocked";
}

export const isIpBlockedError = (error: any): error is IpBlockResponse => {
  try {
    const payload = error instanceof Error ? error.message : error;
    const parsed = typeof payload === "string" ? JSON.parse(payload) : payload;
    return parsed?.type === "ip_blocked";
  } catch {
    return false;
  }
};

export const parseIpBlockError = (error: any): IpBlockResponse | null => {
  try {
    const payload = error instanceof Error ? error.message : error;
    const parsed = typeof payload === "string" ? JSON.parse(payload) : payload;
    if (parsed?.type === "ip_blocked") {
      return parsed;
    }
  } catch {
    // Ignore parse errors
  }
  return null;
};

export const handleIpBlockedError = (dispatch: ApplicationDispatch, error: any) => {
  const ipBlockError = parseIpBlockError(error);
  if (ipBlockError) {
    dispatch({
      type: SET_IP_BLOCKED,
      payload: {
        blocked: true,
        message: ipBlockError.error
      }
    });
  }
};
